module.exports = __webpack_public_path__ + "img/07.a2ce48ed.png";